module.exports = __webpack_public_path__ + "img/feature_1.658a6d73.png";